export type IRemoveSpacesAndLineBreaks = (s: string) => string;

export function removeSpacesAndLineBreaks(s: string): string {
  let str = s;
  if (typeof str === 'string') {
    str = str.replace(/(\r\n|\n|\r)/gm, '');
    str = str.trim();
    return str;
  }
  if (window.debug) {
    console.warn('Warning: string passed to removeSpacesAndLineBreaks is not typeof string.');
  }
  return '';
}
